import { render, staticRenderFns } from "./CardSectionDocuments.vue?vue&type=template&id=c7a47d92&scoped=true&"
import script from "./CardSectionDocuments.vue?vue&type=script&lang=js&"
export * from "./CardSectionDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CardSectionDocuments.vue?vue&type=style&index=0&id=c7a47d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a47d92",
  null
  
)

export default component.exports
import {QCardSection,QCardActions,QBtn,QTooltip,QSeparator} from 'quasar'
component.options.components = Object.assign({QCardSection,QCardActions,QBtn,QTooltip,QSeparator}, component.options.components || {})
